import React from 'react'

export default function ServerError(){
    return <></>
}